import { getProvider } from '../../lib/providers'

interface Props {
  modelId: string
  size?: 'sm' | 'md'
}

export default function ProviderBadge({ modelId, size = 'sm' }: Props) {
  const { color, label } = getProvider(modelId)
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1 text-[13px]'
      }`}
      style={{ backgroundColor: color + '1a', color }}
    >
      {label}
    </span>
  )
}
